import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Popconfirm, Table} from 'antd';
import {uuid} from "../../../utils";
import '../components/resourcePool/resourcePool.css'

import  pic from '../../allResources/img/video.png'

export default class Story extends Component {
    static defaultProps = {
        columns: [
            {
                title: '标题',
                dataIndex: 'name',
            },
            {
                title: '创建单位',
                dataIndex: 'age',
            },
            {
                title: '发布媒体',
                dataIndex: 'address',
            },
            {
                title: '发布时间',
                dataIndex: 'address',
            },
            {
                title: '操作',
                dataIndex: 'address',
            },
        ],
        data:[
            {
                key: '1',
                name: 'John Brown',
                age: '信息单位',
                address: '博达单位',
            },
            {
                key: '2',
                name: 'Jim Green',
                age: '信息单位',
                address: '博达单位',
            },
            {
                key: '3',
                name: 'Joe Black',
                age: '信息单位',
                address: '博达单位',
            },

        ],
        type:'list',
        createTime:'2020-12-22 16:10:11',
        singleClick:()=>{

        },
        doubleClick:()=>{
            console.log('双击')
        },

    };
    static propTypes = {
        columns:PropTypes.array.isRequired,
        data:PropTypes.array.isRequired,

    };
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    componentWillMount() {
    }
    componentDidMount() {
    }

    render(){

        return(
            <div>
                <Table  columns={this.props.columns} dataSource={this.props.data} />
            </div>
        )

    }
    //渲染小 中，大



}